import { useLocation } from "react-router-dom";

/**
 * BreadcrumbList (schema.org) pour les pages qui n'en déclarent pas déjà un.
 *
 * C'est ce qui fait afficher « studiotvai.com › Compiler » sous le lien dans les
 * résultats Google et Bing, à la place de l'URL brute. Meilleur taux de clic pour
 * un coût nul.
 *
 * Monté une seule fois dans AppShell : rendu dans l'arbre (donc capturé par le
 * prerender) et mis à jour à chaque navigation client via useLocation.
 *
 * /llm-vram-calculator et /ai-ml-architect sont exclues : elles déclarent déjà
 * leur propre BreadcrumbList dans le JSON-LD de la page, en dupliquer un second
 * n'apporterait rien et brouillerait le balisage.
 */
const LABELS: Record<string, string> = {
  "/gradient-descent": "Gradient Descent",
  "/compiler": "Build Your Compiler",
  "/lakehouse": "Build a Lakehouse",
  "/mcp": "Model Context Protocol",
};

const SITE = "https://studiotvai.com";

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const name = LABELS[pathname];
  if (!name) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
      { "@type": "ListItem", position: 2, name, item: `${SITE}${pathname}` },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
